module.exports = __webpack_public_path__ + "img/document-export.a568baf1.svg";